import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "upload-id-img"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-title"
};
const _hoisted_5 = {
  class: "popup-content"
};
const _hoisted_6 = {
  class: "upload-content"
};
const _hoisted_7 = {
  class: "flex"
};
import { ref, inject, onMounted } from 'vue';
import { showLoadingToast } from 'vant';
import { useI18n } from 'vue-i18n';
import { useImageTool } from '@/hooks';
import { uploadImg } from '@/api';
export default {
  __name: 'UploadId',
  props: ['modelValue'],
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const MyToast = inject('myToast');
    const {
      t
    } = useI18n();
    const {
      compressImage
    } = useImageTool();
    onMounted(() => {
      //用于app调用js方法
      if (window.$bridge) {
        window.$bridge.registerHandler('uploadCallback', imgUrl => {
          MyToast({
            type: 'success',
            message: t('notify.operateSuccess')
          });
          emit('update:modelValue', imgUrl);
          emit('onClose');
        });
      }
    });
    const doUpload = () => {
      console.log('doUpload');
      if (window.$bridge) {
        window.$bridge.callHandler('upload');
      }
    };
    const afterRead = async (e, target) => {
      try {
        let compressLoading = showLoadingToast({
          message: t('common.loading') + '...',
          forbidClick: true,
          duration: 0
        });
        const compressedFile = await compressImage(e.file);
        compressLoading.close();
        const formData = new FormData();
        formData.append('file', compressedFile);
        uploadImg(formData).then(res => {
          updateValue(res.data);
          // form[target] = res.data;
          // fileList[target] = [{ url: res.data }];
        }).catch(() => {
          // fileList[target] = [];
        });
      } catch (error) {
        console.error('Upload error:', error);
        // 处理错误，比如显示提示信息
      }
    };
    const onOversize = file => {
      MyToast({
        type: 'fail',
        message: t('msg.oversize')
      });
    };
    const updateValue = imgUrl => {
      emit('update:modelValue', imgUrl);
      emit('onClose');
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('uploadId.selfieTitle')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('uploadId.selfieContent')), 1), _createElementVNode("ul", _hoisted_7, [_createElementVNode("li", null, _toDisplayString(_ctx.$t('user.baseInfo.fullName')) + ":", 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.baseInfo.idPhoto')) + ":", 1), _createElementVNode("li", null, _toDisplayString(_ctx.$t('user.baseInfo.dateOfBirth')) + ":", 1)]), _createVNode(_component_van_image, {
          class: "upload-img",
          src: require('@/assets/img/user/verification/selfie.png')
        }, null, 8, ["src"]), _createVNode(_component_van_uploader, {
          accept: "image/*",
          "after-read": e => afterRead(e, 'selfieImg'),
          "max-count": 1,
          "max-size": 10 * 1024 * 1024,
          onClickUpload: doUpload,
          onOversize: onOversize
        }, {
          default: _withCtx(() => [_createVNode(_component_van_button, {
            class: "upload-btn",
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('uploadId.uploadBtn')), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["after-read"])])])]),
        _: 1
      })]);
    };
  }
};